export default class MessageQuery {

    /*public static CreateMessage = `mutation CreateMessageQuery($input: MessageInput) {
            createMessage(input: $input) {
                id
            }
        }`;

    public static DeleteMessage = `mutation DeleteMessageQuery($id: ID!) {
            deleteMessage(id: $id) {
                id
            }
        }`;

    public static GetMessages = `query GetMessagesQuery {
            getMessages {
                id
                projectId
                channels
                pushNotificationBody
                pushNotificationDate
                appScreen,
                appScreenParameter,
                numberOfDevices
                completed
                timestamp
            }
        }`;*/

    public static SendPushNotifications = `mutation SendPushNotificationQuery($input: PushNotificationInput) {
            sendPushNotifications(input: $input) {
                success
            }
        }`;
}